// // export default function ClientPage() {
// //   return (
// //     <div style={{ padding: "120px 20px" }}>
// //       <h1>Client Page</h1>
// //     </div>
// //   );
// // }



















// // // // // export default function Enterprise() {
// // // // //   return (
// // // // //     <div style={{ padding: "100px 20px" }}>
// // // // //       <h1>Enterprise Page</h1>
// // // // //       <p>This is Enterprise section</p>
// // // // //     </div>
// // // // //   );
// // // // // }















// // // // // import { motion } from "framer-motion";
// // // // // import {
// // // // //   Building2,
// // // // //   Shield,
// // // // //   Users,
// // // // //   Database,
// // // // //   BarChart3,
// // // // //   Lock
// // // // // } from "lucide-react";

// // // // // const Enterprise = () => {
// // // // //   const features = [
// // // // //     {
// // // // //       icon: Building2,
// // // // //       title: "Enterprise-Grade Infrastructure",
// // // // //       desc: "Built for law firms, legal departments, and institutions requiring scalability and performance."
// // // // //     },
// // // // //     {
// // // // //       icon: Users,
// // // // //       title: "Team Collaboration",
// // // // //       desc: "Enable seamless collaboration across teams with shared cases, roles, and permissions."
// // // // //     },
// // // // //     {
// // // // //       icon: Database,
// // // // //       title: "Centralized Data Management",
// // // // //       desc: "Access all case data, documents, and analytics from one unified system."
// // // // //     },
// // // // //     {
// // // // //       icon: Shield,
// // // // //       title: "Advanced Security",
// // // // //       desc: "Bank-level encryption and strict access control to safeguard sensitive legal data."
// // // // //     },
// // // // //     {
// // // // //       icon: BarChart3,
// // // // //       title: "Insights & Analytics",
// // // // //       desc: "Track performance, case progress, and team efficiency with powerful analytics."
// // // // //     },
// // // // //     {
// // // // //       icon: Lock,
// // // // //       title: "Custom Access Control",
// // // // //       desc: "Define roles and permissions for complete control over your organization's workflow."
// // // // //     }
// // // // //   ];

// // // // //   return (
// // // // //     <section className="relative w-full min-h-screen bg-white overflow-hidden">

// // // // //       {/* Background gradient glow */}
// // // // //       <div className="absolute inset-0 opacity-[0.06]"
// // // // //         style={{
// // // // //           background:
// // // // //             "radial-gradient(circle at 20% 20%, #cda454 0%, transparent 40%), radial-gradient(circle at 80% 80%, #cda454 0%, transparent 40%)"
// // // // //         }}
// // // // //       />

// // // // //       {/* HERO SECTION (Split Layout) */}
// // // // //       <div className="relative z-10 max-w-7xl mx-auto px-6 pt-[120px] pb-24 grid lg:grid-cols-2 gap-12 items-center">

// // // // //         {/* LEFT TEXT */}
// // // // //         <motion.div
// // // // //           initial={{ opacity: 0, x: -60 }}
// // // // //           animate={{ opacity: 1, x: 0 }}
// // // // //           transition={{ duration: 0.8 }}
// // // // //         >
// // // // //           <h1 className="text-[34px] sm:text-[50px] font-extrabold text-[#111] leading-tight">
// // // // //             Powering Legal
// // // // //             <span className="block text-[#cda454]">Enterprises at Scale</span>
// // // // //           </h1>

// // // // //           <p className="mt-6 text-[16px] sm:text-[18px] text-[#555] leading-relaxed">
// // // // //             Jurident Enterprise is designed for organizations that demand
// // // // //             scalability, control, and efficiency. Manage teams, streamline
// // // // //             operations, and unlock deeper insights — all from a single platform.
// // // // //           </p>

// // // // //           <button className="mt-8 px-8 py-3 rounded-full bg-[#cda454] text-white font-semibold
// // // // //             shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl">
// // // // //             Request Demo
// // // // //           </button>
// // // // //         </motion.div>

// // // // //         {/* RIGHT VISUAL CARD */}
// // // // //         <motion.div
// // // // //           initial={{ opacity: 0, x: 60 }}
// // // // //           animate={{ opacity: 1, x: 0 }}
// // // // //           transition={{ duration: 0.8 }}
// // // // //           className="relative"
// // // // //         >
// // // // //           <div className="bg-white/70 backdrop-blur-xl p-8 rounded-3xl
// // // // //             border border-[#cda454]/10
// // // // //             shadow-[0_30px_80px_rgba(0,0,0,0.12)]">

// // // // //             <h3 className="text-xl font-semibold text-[#111] mb-4">
// // // // //               Why Enterprise?
// // // // //             </h3>

// // // // //             <ul className="space-y-3 text-[#444] text-[15px]">
// // // // //               <li>✔ Multi-team case management</li>
// // // // //               <li>✔ Role-based access control</li>
// // // // //               <li>✔ High-volume case handling</li>
// // // // //               <li>✔ Real-time analytics dashboard</li>
// // // // //               <li>✔ Secure cloud infrastructure</li>
// // // // //             </ul>
// // // // //           </div>
// // // // //         </motion.div>
// // // // //       </div>

// // // // //       {/* FEATURES SECTION (Horizontal Cards Style) */}
// // // // //       <div className="relative z-10 max-w-7xl mx-auto px-6 pb-28">
// // // // //         <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">

// // // // //           {features.map((item, index) => {
// // // // //             const Icon = item.icon;
// // // // //             return (
// // // // //               <motion.div
// // // // //                 key={index}
// // // // //                 initial={{ opacity: 0, y: 70 }}
// // // // //                 whileInView={{ opacity: 1, y: 0 }}
// // // // //                 viewport={{ once: true }}
// // // // //                 transition={{ duration: 0.6, delay: index * 0.1 }}
// // // // //                 className="group p-6 rounded-2xl bg-white
// // // // //                 border border-[#cda454]/10
// // // // //                 shadow-[0_15px_50px_rgba(0,0,0,0.08)]
// // // // //                 hover:-translate-y-2 transition-all duration-500"
// // // // //               >
// // // // //                 {/* Icon */}
// // // // //                 <div className="w-12 h-12 rounded-full bg-[#cda454]/15 flex items-center justify-center mb-4">
// // // // //                   <Icon className="w-5 h-5 text-[#cda454]" />
// // // // //                 </div>

// // // // //                 <h3 className="text-[18px] font-semibold text-[#111] mb-2">
// // // // //                   {item.title}
// // // // //                 </h3>

// // // // //                 <p className="text-[14px] sm:text-[16px] text-[#444] leading-relaxed">
// // // // //                   {item.desc}
// // // // //                 </p>
// // // // //               </motion.div>
// // // // //             );
// // // // //           })}

// // // // //         </div>
// // // // //       </div>

// // // // //       {/* FINAL CTA */}
// // // // //       <div className="relative z-10 max-w-5xl mx-auto px-6 pb-32">
// // // // //         <motion.div
// // // // //           initial={{ opacity: 0, scale: 0.95 }}
// // // // //           whileInView={{ opacity: 1, scale: 1 }}
// // // // //           transition={{ duration: 0.6 }}
// // // // //           className="text-center"
// // // // //         >
// // // // //           <h2 className="text-[26px] sm:text-[34px] font-bold text-[#111]">
// // // // //             Scale your legal operations with confidence
// // // // //           </h2>

// // // // //           <p className="mt-4 text-[#555] text-[16px]">
// // // // //             Built for growing teams, trusted by professionals.
// // // // //           </p>

// // // // //           <button className="mt-6 px-10 py-3 rounded-full border border-[#cda454]
// // // // //             text-[#cda454] font-semibold
// // // // //             transition-all duration-300 hover:bg-[#cda454] hover:text-white">
// // // // //             Contact Sales
// // // // //           </button>
// // // // //         </motion.div>
// // // // //       </div>
// // // // //     </section>
// // // // //   );
// // // // // };

// // // // // export default Enterprise;
























// // // // // import { motion } from "framer-motion";
// // // // // import {
// // // // //   Building2,
// // // // //   Users,
// // // // //   Shield,
// // // // //   Database,
// // // // //   Layers,
// // // // //   ArrowRight
// // // // // } from "lucide-react";

// // // // // const Enterprise = () => {
// // // // //   return (
// // // // //     <section className="relative w-full bg-white overflow-hidden">

// // // // //       {/* Soft background texture */}
// // // // //       <div className="absolute inset-0 opacity-[0.04]"
// // // // //         style={{
// // // // //           backgroundImage:
// // // // //             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
// // // // //           backgroundSize: "32px 32px"
// // // // //         }}
// // // // //       />

// // // // //       {/* ================= HERO ================= */}
// // // // //       <div className="max-w-7xl mx-auto px-6 pt-[130px] pb-24">
// // // // //         <motion.div
// // // // //           initial={{ opacity: 0, y: 60 }}
// // // // //           animate={{ opacity: 1, y: 0 }}
// // // // //           transition={{ duration: 0.9 }}
// // // // //           className="text-center"
// // // // //         >
// // // // //           <h1 className="text-[36px] sm:text-[56px] font-extrabold leading-tight text-[#111]">
// // // // //             Enterprise Legal Infrastructure
// // // // //             <span className="block text-[#cda454]">
// // // // //               Built for Scale & Control
// // // // //             </span>
// // // // //           </h1>

// // // // //           <p className="mt-6 max-w-3xl mx-auto text-[16px] sm:text-[20px] text-[#555] leading-relaxed">
// // // // //             Designed for law firms, corporate legal teams, and institutions 
// // // // //             Jurident Enterprise gives you full control, deep insights, and
// // // // //             unmatched efficiency across your entire legal ecosystem.
// // // // //           </p>

// // // // //           <button className="mt-8 px-10 py-3 rounded-full bg-[#cda454] text-white font-semibold
// // // // //             shadow-lg hover:scale-105 transition-all duration-300">
// // // // //             Request Enterprise Access
// // // // //           </button>
// // // // //         </motion.div>
// // // // //       </div>

// // // // //       {/* ================= TRUST BAR ================= */}
// // // // //       <div className="max-w-6xl mx-auto px-6 pb-20">
// // // // //         <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
// // // // //           {["Law Firms", "Corporate Teams", "Gov Bodies", "Legal Ops"].map((item, i) => (
// // // // //             <div key={i} className="py-6 rounded-xl bg-white/60 backdrop-blur-md border border-[#cda454]/10">
// // // // //               <p className="text-[#111] font-medium">{item}</p>
// // // // //             </div>
// // // // //           ))}
// // // // //         </div>
// // // // //       </div>

// // // // //       {/* ================= SECTION 1 ================= */}
// // // // //       <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-16 items-center">

// // // // //         {/* LEFT TEXT */}
// // // // //         <motion.div
// // // // //           initial={{ opacity: 0, x: -60 }}
// // // // //           whileInView={{ opacity: 1, x: 0 }}
// // // // //           transition={{ duration: 0.8 }}
// // // // //         >
// // // // //           <h2 className="text-[30px] sm:text-[42px] font-bold text-[#111] leading-tight">
// // // // //             Manage Everything
// // // // //             <span className="block text-[#cda454]">In One System</span>
// // // // //           </h2>

// // // // //           <p className="mt-6 text-[#555] text-[16px] leading-relaxed">
// // // // //             Eliminate fragmented workflows. Centralize case management,
// // // // //             documents, teams, and analytics into a single unified platform
// // // // //             built for enterprise efficiency.
// // // // //           </p>
// // // // //         </motion.div>

// // // // //         {/* RIGHT CARD */}
// // // // //         <motion.div
// // // // //           initial={{ opacity: 0, x: 60 }}
// // // // //           whileInView={{ opacity: 1, x: 0 }}
// // // // //           transition={{ duration: 0.8 }}
// // // // //           className="bg-white/70 backdrop-blur-xl p-8 rounded-3xl
// // // // //           shadow-[0_25px_80px_rgba(0,0,0,0.12)] border border-[#cda454]/10"
// // // // //         >
// // // // //           <div className="space-y-4">
// // // // //             <p>✔ Centralized case dashboard</p>
// // // // //             <p>✔ Document lifecycle tracking</p>
// // // // //             <p>✔ Multi-team coordination</p>
// // // // //             <p>✔ Automated workflows</p>
// // // // //           </div>
// // // // //         </motion.div>
// // // // //       </div>

// // // // //       {/* ================= SECTION 2 ================= */}
// // // // //       <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-16 items-center">

// // // // //         {/* LEFT CARD */}
// // // // //         <motion.div
// // // // //           initial={{ opacity: 0, x: -60 }}
// // // // //           whileInView={{ opacity: 1, x: 0 }}
// // // // //           transition={{ duration: 0.8 }}
// // // // //           className="bg-white/70 backdrop-blur-xl p-8 rounded-3xl
// // // // //           shadow-[0_25px_80px_rgba(0,0,0,0.12)] border border-[#cda454]/10"
// // // // //         >
// // // // //           <div className="space-y-4">
// // // // //             <p>✔ Role-based access</p>
// // // // //             <p>✔ Secure document handling</p>
// // // // //             <p>✔ Audit logs</p>
// // // // //             <p>✔ Data privacy compliance</p>
// // // // //           </div>
// // // // //         </motion.div>

// // // // //         {/* RIGHT TEXT */}
// // // // //         <motion.div
// // // // //           initial={{ opacity: 0, x: 60 }}
// // // // //           whileInView={{ opacity: 1, x: 0 }}
// // // // //           transition={{ duration: 0.8 }}
// // // // //         >
// // // // //           <h2 className="text-[30px] sm:text-[42px] font-bold text-[#111] leading-tight">
// // // // //             Security You Can
// // // // //             <span className="block text-[#cda454]">Trust Blindly</span>
// // // // //           </h2>

// // // // //           <p className="mt-6 text-[#555] text-[16px] leading-relaxed">
// // // // //             Enterprise-grade security ensures your legal data is protected at
// // // // //             every level — from access control to encrypted storage and secure
// // // // //             collaboration.
// // // // //           </p>
// // // // //         </motion.div>
// // // // //       </div>

// // // // //       {/* ================= FEATURES GRID ================= */}
// // // // //        <div className="max-w-7xl mx-auto px-6 py-24">
// // // // //         <h2 className="text-center text-[28px] sm:text-[40px] font-bold text-[#111] mb-14">
// // // // //           Enterprise Capabilities
// // // // //         </h2>

// // // // //         <div className="grid md:grid-cols-3 gap-10">
// // // // //           {[
// // // // //             { icon: Users, title: "Team Collaboration" },
// // // // //             { icon: Database, title: "Data Control" },
// // // // //             { icon: Shield, title: "Security Layer" },
// // // // //             { icon: Layers, title: "Scalable System" },
// // // // //             { icon: Building2, title: "Organization Ready" },
// // // // //             { icon: ArrowRight, title: "Workflow Automation" }
// // // // //           ].map((item, i) => {
// // // // //             const Icon = item.icon;
// // // // //             return (
// // // // //               <motion.div
// // // // //                 key={i}
// // // // //                 initial={{ opacity: 0, y: 60 }}
// // // // //                 whileInView={{ opacity: 1, y: 0 }}
// // // // //                 transition={{ duration: 0.6, delay: i * 0.1 }}
// // // // //                 className="p-6 rounded-2xl border border-[#cda454]/10
// // // // //                 bg-white hover:-translate-y-2 transition-all duration-300
// // // // //                 shadow-[0_15px_50px_rgba(0,0,0,0.08)]"
// // // // //               >
// // // // //                 <Icon className="w-6 h-6 text-[#cda454] mb-3" />
// // // // //                 <h3 className="font-semibold text-[#111]">{item.title}</h3>
// // // // //               </motion.div>
// // // // //             );
// // // // //           })}
// // // // //         </div>
// // // // //       </div> 

// // // // //       {/* ================= FINAL CTA ================= */}
// // // // //       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
// // // // //         <motion.div
// // // // //           initial={{ opacity: 0, scale: 0.95 }}
// // // // //           whileInView={{ opacity: 1, scale: 1 }}
// // // // //           transition={{ duration: 0.6 }}
// // // // //           className="bg-white/70 backdrop-blur-xl p-12 rounded-3xl
// // // // //           border border-[#cda454]/10 shadow-[0_25px_80px_rgba(0,0,0,0.12)]"
// // // // //         >
// // // // //           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
// // // // //             Ready to Scale Your Legal Operations?
// // // // //           </h2>

// // // // //           <p className="mt-4 text-[#555] text-[16px]">
// // // // //             Let’s build your enterprise legal ecosystem together.
// // // // //           </p>

// // // // //           <button className="mt-6 px-10 py-3 rounded-full bg-[#111] text-white font-semibold
// // // // //             hover:scale-105 transition-all duration-300">
// // // // //             Contact Sales
// // // // //           </button>
// // // // //         </motion.div>
// // // // //       </div>

// // // // //     </section>
// // // // //   );
// // // // // };

// // // // // export default Enterprise;
























// // // // import { motion } from "framer-motion";
// // // // import {
// // // //   Building2,
// // // //   Users,
// // // //   Shield,
// // // //   Database,
// // // //   Layers,
// // // //   ArrowRight
// // // // } from "lucide-react";

// // // // const Enterprise = () => {
// // // //   return (
// // // //     <section className="relative w-full bg-white overflow-hidden">

// // // //       {/* Background texture */}
// // // //       <div
// // // //         className="absolute inset-0 opacity-[0.04]"
// // // //         style={{
// // // //           backgroundImage:
// // // //             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
// // // //           backgroundSize: "32px 32px"
// // // //         }}
// // // //       />

// // // //       {/* ================= HERO ================= */}
// // // //       <div className="max-w-7xl mx-auto px-6 pt-[130px] pb-24 text-center">
// // // //         <motion.div
// // // //           initial={{ opacity: 0, y: 60 }}
// // // //           animate={{ opacity: 1, y: 0 }}
// // // //           transition={{ duration: 0.9 }}
// // // //         >
// // // //           <h1 className="text-[36px] sm:text-[56px] font-extrabold text-[#111]">
// // // //             Enterprise Legal Infrastructure
// // // //             <span className="block text-[#cda454]">
// // // //               Built for Scale & Control
// // // //             </span>
// // // //           </h1>

// // // //           <p className="mt-6 max-w-3xl mx-auto text-[#555] text-[16px] sm:text-[20px]">
// // // //             Designed for law firms, corporate legal teams, and institutions.
// // // //             Jurident Enterprise gives you full control, deep insights, and
// // // //             unmatched efficiency.
// // // //           </p>

// // // //           <button className="mt-8 px-10 py-3 rounded-full bg-[#cda454] text-white font-semibold shadow-lg hover:scale-105 transition">
// // // //             Request Enterprise Access
// // // //           </button>
// // // //         </motion.div>
// // // //       </div>

// // // //       {/* ================= TRUST BAR ================= */}
// // // //       <div className="max-w-6xl mx-auto px-6 pb-20 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
// // // //         {["Law Firms", "Corporate Teams", "Gov Bodies", "Legal Ops"].map(
// // // //           (item, i) => (
// // // //             <div
// // // //               key={i}
// // // //               className="py-6 rounded-xl bg-white/60 backdrop-blur border border-[#cda454]/10"
// // // //             >
// // // //               {item}
// // // //             </div>
// // // //           )
// // // //         )}
// // // //       </div>

// // // //       {/* ================= SECTION 1 ================= */}
// // // //       <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-16 items-center">

// // // //         <motion.div
// // // //           initial={{ opacity: 0, x: -60 }}
// // // //           whileInView={{ opacity: 1, x: 0 }}
// // // //         >
// // // //           <h2 className="text-[30px] sm:text-[42px] font-bold">
// // // //             Manage Everything
// // // //             <span className="block text-[#cda454]">In One System</span>
// // // //           </h2>

// // // //           <p className="mt-6 text-[#555]">
// // // //             Centralize case management, documents, teams, and analytics into one unified platform.
// // // //           </p>
// // // //         </motion.div>

// // // //         <div className="p-8 rounded-3xl bg-white/70 backdrop-blur shadow-lg border border-[#cda454]/10">
// // // //           <p>✔ Centralized dashboard</p>
// // // //           <p>✔ Document tracking</p>
// // // //           <p>✔ Team coordination</p>
// // // //           <p>✔ Automation</p>
// // // //         </div>
// // // //       </div>

// // // //       {/* ================= SECTION 2 ================= */}
// // // //       <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-16 items-center">

// // // //         <div className="p-8 rounded-3xl bg-white/70 backdrop-blur shadow-lg border border-[#cda454]/10">
// // // //           <p>✔ Role-based access</p>
// // // //           <p>✔ Secure docs</p>
// // // //           <p>✔ Audit logs</p>
// // // //           <p>✔ Compliance</p>
// // // //         </div>

// // // //         <motion.div
// // // //           initial={{ opacity: 0, x: 60 }}
// // // //           whileInView={{ opacity: 1, x: 0 }}
// // // //         >
// // // //           <h2 className="text-[30px] sm:text-[42px] font-bold">
// // // //             Security You Can
// // // //             <span className="block text-[#cda454]">Trust Blindly</span>
// // // //           </h2>

// // // //           <p className="mt-6 text-[#555]">
// // // //             Enterprise-grade security ensures your legal data is protected at every level.
// // // //           </p>
// // // //         </motion.div>
// // // //       </div>

// // // //       {/* ================= FEATURES ================= */}
// // // //       <div className="max-w-7xl mx-auto px-6 py-24">
// // // //         <h2 className="text-center text-[28px] sm:text-[40px] font-bold mb-14">
// // // //           Enterprise Capabilities
// // // //         </h2>

// // // //         <div className="grid md:grid-cols-3 gap-10">
// // // //           {[Users, Database, Shield, Layers, Building2, ArrowRight].map(
// // // //             (Icon, i) => (
// // // //               <div
// // // //                 key={i}
// // // //                 className="p-6 rounded-2xl border bg-white shadow hover:-translate-y-2 transition"
// // // //               >
// // // //                 <Icon className="text-[#cda454] mb-3" />
// // // //                 <h3 className="font-semibold">Feature {i + 1}</h3>
// // // //               </div>
// // // //             )
// // // //           )}
// // // //         </div>
// // // //       </div>

// // // //       {/* ================= VIDEO SECTION ================= */}
// // // //       <div className="max-w-7xl mx-auto px-6 py-24">

// // // //         <motion.div
// // // //           initial={{ opacity: 0, y: 60 }}
// // // //           whileInView={{ opacity: 1, y: 0 }}
// // // //           className="text-center mb-16"
// // // //         >
// // // //           <h2 className="text-[28px] sm:text-[40px] font-bold">
// // // //             See Jurident in Action
// // // //           </h2>
// // // //           <p className="mt-4 text-[#555]">
// // // //             Watch how everything works in real-time.
// // // //           </p>
// // // //         </motion.div>

// // // //         <div className="grid md:grid-cols-3 gap-10">

// // // //           {[1, 2, 3].map((num) => (
// // // //             <div
// // // //               key={num}
// // // //               className="rounded-3xl overflow-hidden bg-white shadow-lg hover:-translate-y-2 transition"
// // // //             >
// // // //               <video
// // // //                 src={`/videos/video${num}.mp4`}
// // // //                 controls
// // // //                 className="w-full h-[220px] object-cover"
// // // //               />

// // // //               <div className="p-5">
// // // //                 <h3 className="font-semibold">
// // // //                   Video Feature {num}
// // // //                 </h3>
// // // //                 <p className="text-sm text-gray-600 mt-2">
// // // //                   Demo explanation of feature {num}.
// // // //                 </p>
// // // //               </div>
// // // //             </div>
// // // //           ))}

// // // //         </div>
// // // //       </div>

// // // //       {/* ================= CTA ================= */}
// // // //       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
// // // //         <div className="bg-white p-12 rounded-3xl shadow-lg">
// // // //           <h2 className="text-[28px] sm:text-[36px] font-bold">
// // // //             Ready to Scale?
// // // //           </h2>

// // // //           <button className="mt-6 px-10 py-3 rounded-full bg-black text-white hover:scale-105 transition">
// // // //             Contact Sales
// // // //           </button>
// // // //         </div>
// // // //       </div>

// // // //     </section>
// // // //   );
// // // // };

// // // // export default Enterprise;

























// // // // import { motion } from "framer-motion";
// // // // import {
// // // //   Building2,
// // // //   Users,
// // // //   Shield,
// // // //   Database,
// // // //   Layers,
// // // //   ArrowRight
// // // // } from "lucide-react";

// // // // const Enterprise = () => {
// // // //   return (
// // // //     <section className="relative w-full bg-white overflow-hidden">

// // // //       {/* Background texture */}
// // // //       <div
// // // //         className="absolute inset-0 opacity-[0.04]"
// // // //         style={{
// // // //           backgroundImage:
// // // //             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
// // // //           backgroundSize: "32px 32px"
// // // //         }}
// // // //       />

// // // //       {/* ================= HERO ================= */}
// // // //       <div className="max-w-7xl mx-auto px-6 pt-[130px] pb-24 text-center">
// // // //         <motion.div
// // // //           initial={{ opacity: 0, y: 60 }}
// // // //           animate={{ opacity: 1, y: 0 }}
// // // //           transition={{ duration: 0.9 }}
// // // //         >
// // // //           <h1 className="text-[36px] sm:text-[56px] font-extrabold text-[#111]">
// // // //             Enterprise Legal Infrastructure
// // // //             <span className="block text-[#cda454]">
// // // //               Built for Scale & Control
// // // //             </span>
// // // //           </h1>

// // // //           <p className="mt-6 max-w-3xl mx-auto text-[#555] text-[16px] sm:text-[20px]">
// // // //             Designed for law firms, corporate legal teams, and institutions.
// // // //             Jurident Enterprise gives you full control, deep insights, and unmatched efficiency.
// // // //           </p>

// // // //           <button className="mt-8 px-10 py-3 rounded-full bg-[#cda454] text-white font-semibold shadow-lg hover:scale-105 transition">
// // // //             Request Enterprise Access
// // // //           </button>
// // // //         </motion.div>
// // // //       </div>

// // // //       {/* ================= TRUST BAR ================= */}
// // // //       <div className="max-w-6xl mx-auto px-6 pb-20 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
// // // //         {["Law Firms", "Corporate Teams", "Gov Bodies", "Legal Ops"].map(
// // // //           (item, i) => (
// // // //             <div
// // // //               key={i}
// // // //               className="py-6 rounded-xl bg-white border border-[#cda454]/10 shadow-sm"
// // // //             >
// // // //               {item}
// // // //             </div>
// // // //           )
// // // //         )}
// // // //       </div>

// // // //       {/* ================= SECTION 1 ================= */}
// // // //       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

// // // //         {/* TEXT */}
// // // //         <motion.div
// // // //           initial={{ opacity: 0, x: -60 }}
// // // //           whileInView={{ opacity: 1, x: 0 }}
// // // //         >
// // // //           <h2 className="text-[32px] sm:text-[44px] font-bold text-[#111]">
// // // //             Manage Everything
// // // //             <span className="block text-[#cda454]">In One System</span>
// // // //           </h2>

// // // //           <p className="mt-6 text-[#555] text-lg">
// // // //             Centralize case management, documents, teams, and analytics into one powerful system.
// // // //           </p>

// // // //           <ul className="mt-6 space-y-2 text-[#444]">
// // // //             <li>✔ Centralized dashboard</li>
// // // //             <li>✔ Document tracking</li>
// // // //             <li>✔ Team coordination</li>
// // // //             <li>✔ Automation</li>
// // // //           </ul>
// // // //         </motion.div>

// // // //         {/* VIDEO */}
// // // //         <motion.div
// // // //           initial={{ opacity: 0, x: 60 }}
// // // //           whileInView={{ opacity: 1, x: 0 }}
// // // //           className="rounded-3xl overflow-hidden shadow-[0_25px_80px_rgba(0,0,0,0.2)]"
// // // //         >
// // // //           <video
// // // //             src="/videos/video1.mp4"
// // // //             autoPlay
// // // //             loop
// // // //             muted
// // // //             className="w-full h-[350px] object-cover"
// // // //           />
// // // //         </motion.div>
// // // //       </div>

// // // //       {/* ================= SECTION 2 ================= */}
// // // //       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

// // // //         {/* VIDEO */}
// // // //         <motion.div
// // // //           initial={{ opacity: 0, x: -60 }}
// // // //           whileInView={{ opacity: 1, x: 0 }}
// // // //           className="rounded-3xl overflow-hidden shadow-[0_25px_80px_rgba(0,0,0,0.2)]"
// // // //         >
// // // //           <video
// // // //             src="/videos/video2.mp4"
// // // //             autoPlay
// // // //             loop
// // // //             muted
// // // //             className="w-full h-[350px] object-cover"
// // // //           />
// // // //         </motion.div>

// // // //         {/* TEXT */}
// // // //         <motion.div
// // // //           initial={{ opacity: 0, x: 60 }}
// // // //           whileInView={{ opacity: 1, x: 0 }}
// // // //         >
// // // //           <h2 className="text-[32px] sm:text-[44px] font-bold text-[#111]">
// // // //             Security You Can
// // // //             <span className="block text-[#cda454]">Trust Blindly</span>
// // // //           </h2>

// // // //           <p className="mt-6 text-[#555] text-lg">
// // // //             Enterprise-grade security ensures your legal data is protected at every level.
// // // //           </p>

// // // //           <ul className="mt-6 space-y-2 text-[#444]">
// // // //             <li>✔ Role-based access</li>
// // // //             <li>✔ Secure documents</li>
// // // //             <li>✔ Audit logs</li>
// // // //             <li>✔ Compliance</li>
// // // //           </ul>
// // // //         </motion.div>
// // // //       </div>

// // // //       {/* ================= FEATURES ================= */}
// // // //       <div className="max-w-7xl mx-auto px-6 py-24">
// // // //         <h2 className="text-center text-[28px] sm:text-[40px] font-bold mb-14">
// // // //           Enterprise Capabilities
// // // //         </h2>

// // // //         <div className="grid md:grid-cols-3 gap-10">
// // // //           {[Users, Database, Shield, Layers, Building2, ArrowRight].map(
// // // //             (Icon, i) => (
// // // //               <div
// // // //                 key={i}
// // // //                 className="p-6 rounded-2xl border bg-white shadow hover:-translate-y-2 transition"
// // // //               >
// // // //                 <Icon className="text-[#cda454] mb-3" />
// // // //                 <h3 className="font-semibold">Feature {i + 1}</h3>
// // // //               </div>
// // // //             )
// // // //           )}
// // // //         </div>
// // // //       </div>

// // // //       {/* ================= BIG VIDEO ================= */}
// // // //       <div className="max-w-6xl mx-auto px-6 py-24">

// // // //         <motion.div
// // // //           initial={{ opacity: 0, scale: 0.95 }}
// // // //           whileInView={{ opacity: 1, scale: 1 }}
// // // //           className="rounded-3xl overflow-hidden shadow-[0_30px_100px_rgba(0,0,0,0.25)]"
// // // //         >
// // // //           <video
// // // //             src="/videos/video3.mp4"
// // // //             autoPlay
// // // //             loop
// // // //             muted
// // // //             className="w-full h-[500px] object-cover"
// // // //           />
// // // //         </motion.div>

// // // //         <div className="text-center mt-10">
// // // //           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
// // // //             Experience the Full Platform
// // // //           </h2>
// // // //           <p className="text-[#555] mt-4">
// // // //             Watch how Jurident transforms enterprise legal workflows end-to-end.
// // // //           </p>
// // // //         </div>

// // // //       </div>

// // // //       {/* ================= CTA ================= */}
// // // //       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
// // // //         <div className="bg-white p-12 rounded-3xl shadow-lg">
// // // //           <h2 className="text-[28px] sm:text-[36px] font-bold">
// // // //             Ready to Scale Your Legal Operations?
// // // //           </h2>

// // // //           <p className="mt-4 text-[#555]">
// // // //             Let’s build your enterprise legal ecosystem together.
// // // //           </p>

// // // //           <button className="mt-6 px-10 py-3 rounded-full bg-black text-white hover:scale-105 transition">
// // // //             Contact Sales
// // // //           </button>
// // // //         </div>
// // // //       </div>

// // // //     </section>
// // // //   );
// // // // };

// // // // export default Enterprise;





























// // // import { motion } from "framer-motion";
// // // import {
// // //   Building2,
// // //   Users,
// // //   Shield,
// // //   Database,
// // //   Layers,
// // //   ArrowRight
// // // } from "lucide-react";

// // // const Enterprise = () => {
// // //   return (
// // //     <section className="relative w-full bg-white overflow-hidden">

// // //       {/* Background */}
// // //       <div
// // //         className="absolute inset-0 opacity-[0.04]"
// // //         style={{
// // //           backgroundImage:
// // //             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
// // //           backgroundSize: "32px 32px"
// // //         }}
// // //       />

// // //       {/* ================= HERO ================= */}
// // //       <div className="max-w-7xl mx-auto px-6 pt-[130px] pb-24 text-center">
// // //         <motion.div
// // //           initial={{ opacity: 0, y: 60 }}
// // //           animate={{ opacity: 1, y: 0 }}
// // //         >
// // //           <h1 className="text-[36px] sm:text-[56px] font-extrabold text-[#111]">
// // //             Enterprise Legal Infrastructure
// // //             <span className="block text-[#cda454]">
// // //               Built for Scale & Control
// // //             </span>
// // //           </h1>

// // //           <p className="mt-6 max-w-3xl mx-auto text-[#222] text-[18px]">
// // //             Designed for law firms, corporate legal teams, and institutions.
// // //             Jurident Enterprise gives you full control, deep insights, and unmatched efficiency.
// // //           </p>

// // //           <button className="mt-8 px-10 py-3 rounded-full bg-[#cda454] text-white font-semibold hover:scale-105 transition">
// // //             Request Enterprise Access
// // //           </button>
// // //         </motion.div>
// // //       </div>

// // //       {/* ================= TRUST BAR ================= */}
// // //       <div className="max-w-6xl mx-auto px-6 pb-20 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
// // //         {["Law Firms", "Corporate Teams", "Gov Bodies", "Legal Ops"].map(
// // //           (item, i) => (
// // //             <div
// // //               key={i}
// // //               className="py-6 rounded-xl bg-transparent border border-[#d1d5db]
// // //               text-[#111] font-medium hover:border-[#cda454] transition"
// // //             >
// // //               {item}
// // //             </div>
// // //           )
// // //         )}
// // //       </div>

// // //       {/* ================= SECTION 1 ================= */}
// // //       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

// // //         <motion.div>
// // //           <h2 className="text-[32px] sm:text-[44px] font-bold text-[#111]">
// // //             Manage Everything
// // //             <span className="block text-[#cda454]">In One System</span>
// // //           </h2>

// // //           <p className="mt-6 text-[#333] text-lg">
// // //             Centralize case management, documents, teams, and analytics into one powerful system.
// // //           </p>

// // //           <ul className="mt-6 space-y-2 text-[#222]">
// // //             <li>✔ Centralized dashboard</li>
// // //             <li>✔ Document tracking</li>
// // //             <li>✔ Team coordination</li>
// // //             <li>✔ Automation</li>
// // //           </ul>
// // //         </motion.div>

// // //         <video
// // //           src="/videos/video1.mp4"
// // //           autoPlay
// // //           loop
// // //           muted
// // //           className="rounded-3xl shadow-xl h-[350px] w-full object-cover"
// // //         />
// // //       </div>

// // //       {/* ================= SECTION 2 ================= */}
// // //       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

// // //         <video
// // //           src="/videos/video2.mp4"
// // //           autoPlay
// // //           loop
// // //           muted
// // //           className="rounded-3xl shadow-xl h-[350px] w-full object-cover"
// // //         />

// // //         <div>
// // //           <h2 className="text-[32px] sm:text-[44px] font-bold text-[#111]">
// // //             Security You Can
// // //             <span className="block text-[#cda454]">Trust Blindly</span>
// // //           </h2>

// // //           <p className="mt-6 text-[#333] text-lg">
// // //             Enterprise-grade security ensures your legal data is protected at every level.
// // //           </p>

// // //           <ul className="mt-6 space-y-2 text-[#222]">
// // //             <li>✔ Role-based access</li>
// // //             <li>✔ Secure documents</li>
// // //             <li>✔ Audit logs</li>
// // //             <li>✔ Compliance</li>
// // //           </ul>
// // //         </div>
// // //       </div>

// // //       {/* ================= FEATURES ================= */}
// // //       <div className="max-w-7xl mx-auto px-6 py-24">
// // //         <h2 className="text-center text-[28px] sm:text-[40px] font-bold text-[#111] mb-14">
// // //           Enterprise Capabilities
// // //         </h2>

// // //         <div className="grid md:grid-cols-3 gap-10">
// // //           {[Users, Database, Shield, Layers, Building2, ArrowRight].map(
// // //             (Icon, i) => (
// // //               <div
// // //                 key={i}
// // //                 className="p-6 rounded-2xl border border-[#d1d5db]
// // //                 bg-transparent hover:border-[#cda454]
// // //                 transition-all duration-300"
// // //               >
// // //                 <Icon className="text-[#cda454] mb-3" />
// // //                 <h3 className="font-semibold text-[#111]">
// // //                   Feature {i + 1}
// // //                 </h3>
// // //               </div>
// // //             )
// // //           )}
// // //         </div>
// // //       </div>

// // //       {/* ================= BIG VIDEO ================= */}
// // //       <div className="max-w-6xl mx-auto px-6 py-24">

// // //         <motion.div className="rounded-3xl overflow-hidden shadow-[0_30px_100px_rgba(0,0,0,0.25)]">
// // //           <video
// // //             src="/videos/video3.mp4"
// // //             autoPlay
// // //             loop
// // //             muted
// // //             className="w-full h-[500px] object-cover"
// // //           />
// // //         </motion.div>

// // //         <div className="text-center mt-10">
// // //           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
// // //             Experience the Full Platform
// // //           </h2>
// // //           <p className="text-[#333] mt-4">
// // //             Watch how Jurident transforms enterprise legal workflows end-to-end.
// // //           </p>
// // //         </div>

// // //       </div>

// // //       {/* ================= CTA ================= */}
// // //       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
// // //         <div className="bg-transparent border border-[#d1d5db] p-12 rounded-3xl">

// // //           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
// // //             Ready to Scale Your Legal Operations?
// // //           </h2>

// // //           <p className="mt-4 text-[#333]">
// // //             Let’s build your enterprise legal ecosystem together.
// // //           </p>

// // //           <button className="mt-6 px-10 py-3 rounded-full bg-black text-white hover:scale-105 transition">
// // //             Contact Sales
// // //           </button>

// // //         </div>
// // //       </div>

// // //     </section>
// // //   );
// // // };

// // // export default Enterprise;



































// // import { motion } from "framer-motion";
// // import {
// //   Building2,
// //   Users,
// //   Shield,
// //   Database,
// //   Layers,
// //   ArrowRight
// // } from "lucide-react";

// // const Enterprise = () => {

// //   const features = [
// //     {
// //       icon: Users,
// //       title: "Team Collaboration",
// //       desc: "Work seamlessly across departments with real-time collaboration tools."
// //     },
// //     {
// //       icon: Database,
// //       title: "Centralized Data",
// //       desc: "Store and manage all legal data securely in one unified system."
// //     },
// //     {
// //       icon: Shield,
// //       title: "Enterprise Security",
// //       desc: "Advanced security protocols to protect sensitive legal information."
// //     },
// //     {
// //       icon: Layers,
// //       title: "Scalable Infrastructure",
// //       desc: "Built to handle growing workloads for large organizations."
// //     },
// //     {
// //       icon: Building2,
// //       title: "Organization Management",
// //       desc: "Manage multiple teams, roles, and permissions effortlessly."
// //     },
// //     {
// //       icon: ArrowRight,
// //       title: "Workflow Automation",
// //       desc: "Automate repetitive legal processes to save time and effort."
// //     }
// //   ];

// //   return (
// //     <section className="relative w-full bg-white overflow-hidden">

// //       {/* Background */}
// //       <div
// //         className="absolute inset-0 opacity-[0.04]"
// //         style={{
// //           backgroundImage:
// //             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
// //           backgroundSize: "32px 32px"
// //         }}
// //       />

// //       {/* ================= HERO ================= */}
// //       <div className="max-w-7xl mx-auto px-6 pt-[130px] pb-24 text-center">
// //         <motion.div initial={{ opacity: 0, y: 60 }} animate={{ opacity: 1, y: 0 }}>
// //           <h1 className="text-[36px] sm:text-[56px] font-extrabold text-[#111]">
// //             Enterprise Legal Infrastructure
// //             <span className="block text-[#cda454]">
// //               Built for Scale & Control
// //             </span>
// //           </h1>

// //           <p className="mt-6 max-w-3xl mx-auto text-[#222] text-[18px]">
// //             Designed for law firms, corporate legal teams, and institutions.
// //             Jurident Enterprise gives you full control, deep insights, and unmatched efficiency.
// //           </p>

// //           <button className="mt-8 px-10 py-3 rounded-full bg-[#cda454] text-white font-semibold hover:scale-105 transition">
// //             Request Enterprise Access
// //           </button>
// //         </motion.div>
// //       </div>

// //       {/* ================= TRUST BAR ================= */}
// //       <div className="max-w-6xl mx-auto px-6 pb-20 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
// //         {["Law Firms", "Corporate Teams", "Gov Bodies", "Legal Ops"].map((item, i) => (
// //           <div
// //             key={i}
// //             className="py-6 rounded-xl bg-transparent border border-[#d1d5db]
// //             text-[#111] font-medium hover:border-[#cda454] transition"
// //           >
// //             {item}
// //           </div>
// //         ))}
// //       </div>

// //       {/* ================= SECTION 1 ================= */}
// //       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

// //         <div>
// //           <h2 className="text-[32px] sm:text-[44px] font-bold text-[#111]">
// //             Manage Everything
// //             <span className="block text-[#cda454]">In One System</span>
// //           </h2>

// //           <p className="mt-6 text-[#333] text-lg">
// //             Centralize case management, documents, teams, and analytics into one powerful system.
// //           </p>

// //           <ul className="mt-6 space-y-2 text-[#222]">
// //             <li>✔ Centralized dashboard</li>
// //             <li>✔ Document tracking</li>
// //             <li>✔ Team coordination</li>
// //             <li>✔ Automation</li>
// //           </ul>
// //         </div>

// //         <video
// //           src="/videos/video1.mp4"
// //           autoPlay
// //           loop
// //           muted
// //           className="rounded-3xl shadow-xl h-[350px] w-full object-cover"
// //         />
// //       </div>

// //       {/* ================= SECTION 2 ================= */}
// //       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

// //         <video
// //           src="/videos/video2.mp4"
// //           autoPlay
// //           loop
// //           muted
// //           className="rounded-3xl shadow-xl h-[350px] w-full object-cover"
// //         />

// //         <div>
// //           <h2 className="text-[32px] sm:text-[44px] font-bold text-[#111]">
// //             Security You Can
// //             <span className="block text-[#cda454]">Trust Blindly</span>
// //           </h2>

// //           <p className="mt-6 text-[#333] text-lg">
// //             Enterprise-grade security ensures your legal data is protected at every level.
// //           </p>

// //           <ul className="mt-6 space-y-2 text-[#222]">
// //             <li>✔ Role-based access</li>
// //             <li>✔ Secure documents</li>
// //             <li>✔ Audit logs</li>
// //             <li>✔ Compliance</li>
// //           </ul>
// //         </div>
// //       </div>

// //       {/* ================= FEATURES ================= */}
// //       <div className="max-w-7xl mx-auto px-6 py-24">
// //         <h2 className="text-center text-[28px] sm:text-[40px] font-bold text-[#111] mb-14">
// //           Enterprise Capabilities
// //         </h2>

// //         <div className="grid md:grid-cols-3 gap-10">
// //           {features.map((item, i) => {
// //             const Icon = item.icon;
// //             return (
// //               <div
// //                 key={i}
// //                 className="p-6 rounded-2xl border border-[#d1d5db]
// //                 bg-transparent hover:border-[#cda454]
// //                 transition-all duration-300"
// //               >
// //                 <Icon className="text-[#cda454] mb-4 w-6 h-6" />

// //                 <h3 className="font-semibold text-[#111] text-lg">
// //                   {item.title}
// //                 </h3>

// //                 <p className="text-[#444] mt-2 text-sm leading-relaxed">
// //                   {item.desc}
// //                 </p>
// //               </div>
// //             );
// //           })}
// //         </div>
// //       </div>

// //       {/* ================= BIG VIDEO ================= */}
// //       <div className="max-w-6xl mx-auto px-6 py-24 text-center">
// //         <video
// //           src="/videos/video3.mp4"
// //           autoPlay
// //           loop
// //           muted
// //           className="rounded-3xl shadow-2xl w-full h-[500px] object-cover"
// //         />
// //       </div>

// //       {/* ================= CTA ================= */}
// //       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
// //         <div className="bg-transparent border border-[#d1d5db] p-12 rounded-3xl">

// //           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
// //             Ready to Scale Your Legal Operations?
// //           </h2>

// //           <p className="mt-4 text-[#333]">
// //             Let’s build your enterprise legal ecosystem together.
// //           </p>

// //           <button className="mt-6 px-10 py-3 rounded-full bg-black text-white hover:scale-105 transition">
// //             Contact Sales
// //           </button>

// //         </div>
// //       </div>

// //     </section>
// //   );
// // };

// // export default Enterprise;





























// import { motion } from "framer-motion";
// import {
//   Building2,
//   Users,
//   Shield,
//   Database,
//   Layers,
//   ArrowRight
// } from "lucide-react";

// const Enterprise = () => {

//   const features = [
//     {
//       icon: Users,
//       title: "Team Collaboration",
//       desc: "Work seamlessly across departments with real-time collaboration."
//     },
//     {
//       icon: Database,
//       title: "Centralized Data",
//       desc: "Manage all legal data securely in one unified system."
//     },
//     {
//       icon: Shield,
//       title: "Enterprise Security",
//       desc: "Advanced protection for sensitive legal information."
//     },
//     {
//       icon: Layers,
//       title: "Scalable System",
//       desc: "Built to handle enterprise-level workloads smoothly."
//     },
//     {
//       icon: Building2,
//       title: "Organization Control",
//       desc: "Manage teams, roles, and permissions efficiently."
//     },
//     {
//       icon: ArrowRight,
//       title: "Workflow Automation",
//       desc: "Automate repetitive legal processes and save time."
//     }
//   ];

//   return (
//     <section className="relative w-full bg-white overflow-hidden">

//       {/* Background */}
//       <div
//         className="absolute inset-0 opacity-[0.04]"
//         style={{
//           backgroundImage:
//             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
//           backgroundSize: "32px 32px"
//         }}
//       />

//       {/* ================= HERO ================= */}
//       <div className="max-w-7xl mx-auto px-6 pt-[130px] pb-24 text-center">
//         <motion.div
//           initial={{ opacity: 0, y: 60 }}
//           animate={{ opacity: 1, y: 0 }}
//         >
//           <h1 className="text-[36px] sm:text-[56px] font-extrabold text-[#111]">
//             Enterprise Legal Infrastructure
//             <span className="block text-[#cda454]">
//               Built for Scale & Control
//             </span>
//           </h1>

//           <p className="mt-6 max-w-3xl mx-auto text-[#222] text-[18px]">
//             Designed for law firms, corporate legal teams, and institutions.
//             Jurident Enterprise gives you full control, deep insights, and unmatched efficiency.
//           </p>

//           <button className="mt-8 px-10 py-3 rounded-full bg-[#cda454] text-white font-semibold hover:scale-105 transition">
//             Request Enterprise Access
//           </button>
//         </motion.div>
//       </div>

//       {/* ================= TRUST BAR ================= */}
//       <div className="max-w-6xl mx-auto px-6 pb-20 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
//         {["Law Firms", "Corporate Teams", "Gov Bodies", "Legal Ops"].map(
//           (item, i) => (
//             <div
//               key={i}
//               className="py-6 rounded-xl bg-transparent border border-[#d1d5db]
//               text-[#111] font-medium hover:border-[#cda454] transition"
//             >
//               {item}
//             </div>
//           )
//         )}
//       </div>

//       {/* ================= SECTION 1 ================= */}
//       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

//         <motion.div>
//           <h2 className="text-[32px] sm:text-[44px] font-bold text-[#111]">
//             Manage Everything
//             <span className="block text-[#cda454]">In One System</span>
//           </h2>

//           <p className="mt-6 text-[#333] text-lg">
//             Centralize case management, documents, teams, and analytics into one powerful system.
//           </p>

//           <ul className="mt-6 space-y-2 text-[#222]">
//             <li>✔ Centralized dashboard</li>
//             <li>✔ Document tracking</li>
//             <li>✔ Team coordination</li>
//             <li>✔ Automation</li>
//           </ul>
//         </motion.div>

//         <video
//           src="/videos/video1.mp4"
//           autoPlay
//           loop
//           muted
//           className="rounded-3xl shadow-xl h-[350px] w-full object-cover"
//         />
//       </div>

//       {/* ================= SECTION 2 ================= */}
//       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

//         <video
//           src="/videos/video2.mp4"
//           autoPlay
//           loop
//           muted
//           className="rounded-3xl shadow-xl h-[350px] w-full object-cover"
//         />

//         <div>
//           <h2 className="text-[32px] sm:text-[44px] font-bold text-[#111]">
//             Security You Can
//             <span className="block text-[#cda454]">Trust Blindly</span>
//           </h2>

//           <p className="mt-6 text-[#333] text-lg">
//             Enterprise-grade security ensures your legal data is protected at every level.
//           </p>

//           <ul className="mt-6 space-y-2 text-[#222]">
//             <li>✔ Role-based access</li>
//             <li>✔ Secure documents</li>
//             <li>✔ Audit logs</li>
//             <li>✔ Compliance</li>
//           </ul>
//         </div>
//       </div>

//       {/* ================= FEATURES ================= */}
//       <div className="max-w-7xl mx-auto px-6 py-24">
//         <h2 className="text-center text-[28px] sm:text-[40px] font-bold text-[#111] mb-14">
//           Enterprise Capabilities
//         </h2>

//         <div className="grid md:grid-cols-3 gap-10">
//           {features.map((item, i) => {
//             const Icon = item.icon;
//             return (
//               <div
//                 key={i}
//                 className="p-6 rounded-2xl border border-[#d1d5db]
//                 bg-transparent hover:border-[#cda454]
//                 transition-all duration-300"
//               >
//                 <Icon className="text-[#cda454] mb-3" />

//                 <h3 className="font-semibold text-[#111]">
//                   {item.title}
//                 </h3>

//                 <p className="text-[#333] text-sm mt-2">
//                   {item.desc}
//                 </p>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* ================= BIG VIDEO ================= */}
//       <div className="max-w-6xl mx-auto px-6 py-24">

//         <motion.div className="rounded-3xl overflow-hidden shadow-[0_30px_100px_rgba(0,0,0,0.25)]">
//           <video
//             src="/videos/video3.mp4"
//             autoPlay
//             loop
//             muted
//             className="w-full h-[500px] object-cover"
//           />
//         </motion.div>

//         <div className="text-center mt-10">
//           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
//             Experience the Full Platform
//           </h2>
//           <p className="text-[#333] mt-4">
//             Watch how Jurident transforms enterprise legal workflows end-to-end.
//           </p>
//         </div>

//       </div>

//       {/* ================= CTA ================= */}
//       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
//         <div className="bg-transparent border border-[#d1d5db] p-12 rounded-3xl">

//           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
//             Ready to Scale Your Legal Operations?
//           </h2>

//           <p className="mt-4 text-[#333]">
//             Let’s build your enterprise legal ecosystem together.
//           </p>

//           <button className="mt-6 px-10 py-3 rounded-full bg-black text-white hover:scale-105 transition">
//             Contact Sales
//           </button>

//         </div>
//       </div>

//     </section>
//   );
// };

// export default Enterprise;






























// import { motion } from "framer-motion";
// import {
//   Building2,
//   Users,
//   Shield,
//   Database,
//   Layers,
//   ArrowRight,
//   CalendarClock,
//   FileText,
//   Sparkles
// } from "lucide-react";

// const Enterprise = () => {

//   const features = [
//     {
//       icon: Database,
//       title: "Centralized Case Management",
//       desc: "Maintain a single, secure repository for all legal matters, documents, and case history."
//     },
//     {
//       icon: Users,
//       title: "Lawyer-Client Sync",
//       desc: "Collaborate seamlessly with lawyers and law firms, track progress, and ensure accountability."
//     },
//         {
//       icon: Sparkles,
//       title: "AI-Drafting",
//       desc: "Accelerate internal documentation, notices, and case-related drafts with AI support."
//     },
//     {
//       icon: CalendarClock,
//       title: "Smart Scheduling & Alerts",
//       desc: "Stay ahead of hearings, deadlines, and compliance requirements with automated reminders."
//     },
// {
//   icon: Users,
//   title: "Team Collaboration",
//   desc: "Work seamlessly with your team, share updates, and collaborate on cases in real time."
// },
//     {
//       icon: ArrowRight,
//       title: "Expense & Invoice Tracking",
//       desc: "Monitor legal spend, manage billing, and improve cost visibility across all cases."
//     }

//   ];

//   return (
//     <section className="relative w-full bg-white overflow-hidden">

//       {/* Background */}
//       <div
      
//   className="absolute inset-0 opacity-[0.04] pointer-events-none"
//         style={{
//           backgroundImage:
//             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
//           backgroundSize: "32px 32px"
//         }}
//       />

//       {/* 🔥 HERO */}
//       <div className="max-w-7xl mx-auto px-6 pt-[140px] pb-28 text-center">
//         <motion.div initial={{ opacity: 0, y: 60 }} animate={{ opacity: 1, y: 0 }}>

//           {/* <h1 className="text-[40px] sm:text-[64px] font-extrabold leading-tight text-[#111]">
//             Built for
//             <span className="block bg-gradient-to-r from-[#cda454] to-[#e6c16a] bg-clip-text text-transparent">
//               Organizations & Clients
//             </span>
//           </h1> */}
//                    <h1 className="text-[40px] sm:text-[64px] font-extrabold leading-tight text-[#111]">
//           Enterprise Legal Infrastructure
//              <span className="block bg-gradient-to-r from-[#cda454] to-[#e6c16a] bg-clip-text text-transparent">
//                Built for Scale & Control
//              </span>
//            </h1>

//           <p className="mt-6 max-w-3xl mx-auto text-[#444] text-[18px] leading-relaxed">
//           JURIDENT helps organizations to 
// Track cases, Get Hearing Notifications, Organize legal documents, and coordinate seamlessly with your legal teams all in one secure platform. Customise with your needs.
//           </p>

//           {/* <p className="mt-4 max-w-2xl mx-auto text-[#555] text-[16px]">
//             As companies grow, handling multiple cases, deadlines, and communications becomes complex. 
//             JURIDENT simplifies this by providing clear visibility into ongoing matters, helping your team stay organized, informed, and in control.
//           </p> */}

//           {/* BUTTONS */}
//           <div className="flex justify-center gap-4 mt-10 flex-wrap">

//             <a
//   href="/portal"
//   className="group relative px-10 py-3 rounded-full bg-[#cda454] text-white font-semibold hover:scale-105 transition inline-block"
// >
//   Get Started
// </a>

// <a
//   href="/demo"
//   className="group relative px-10 py-3 rounded-full border border-[#111] text-[#111] font-semibold hover:scale-105 transition inline-block"
// >
//   Book Demo
// </a>
//           </div>
//         </motion.div>
//       </div>

//       {/* TRUST BAR */}
//       <div className="max-w-6xl mx-auto px-6 pb-20 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
//         {["Public sector", "Private sector", "MSMEs", "Government"].map(
//           (item, i) => (
//             <div
//               key={i}
//               className="py-6 rounded-xl border border-[#e5e7eb] bg-white/60 backdrop-blur-md
//               text-[#111] font-medium transition-all duration-300
//               hover:border-[#cda454] hover:shadow-xl hover:-translate-y-1"
//             >
//               {item}
//             </div>
//           )
//         )}
//       </div>

//       {/* 🔥 SECTION 1 */}
//       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

//         <motion.div initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }}>

//           <h2 className="text-[34px] sm:text-[48px] font-bold text-[#111]">
//             Manage Legal Matters
//             <span className="block text-[#cda454]">With Full Visibility</span>
//           </h2>

//           <p className="mt-6 text-[#444] text-lg">
//             Track every case, document, and update in one centralized system. Stay informed and in control of all legal operations.
//           </p>

//           <ul className="mt-6 space-y-3 text-[#222]">
//             <li>✔ Lawyer-client synchronization.</li>
//             <li>✔ Centralized case tracking</li>
//             <li>✔ Document organization</li>
//             {/* <li>✔ Real-time updates</li> */}
//             <li>✔ Better decision making</li>
//             <li>✔ AI drafting</li>
            

//           </ul>
//         </motion.div>

//         {/* <video
//           src="/videos/video1.mp4"
//           autoPlay
//           loop
//           muted
//           className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
//         /> */}
//           <img
//           src="legal.jpeg"
          
//           className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
//         />
//       </div>

//       {/* 🔥 SECTION 2 */}
//       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

//         <video
//           src="legelteam.mp4"
//           autoPlay
//           loop
//           muted
//           className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
//         />

//         <motion.div initial={{ opacity: 0, x: 60 }} whileInView={{ opacity: 1, x: 0 }}>

//           <h2 className="text-[34px] sm:text-[48px] font-bold text-[#111]">
//             Stay Ahead With
//             <span className="block text-[#cda454]">Your Legal Tech</span>
//           </h2>

//           <p className="mt-6 text-[#444] text-lg">
//             Collaborate seamlessly with lawyers and law firms. Track progress, communicate efficiently, and ensure accountability.
//           </p>

//           <ul className="mt-6 space-y-3 text-[#222]">
//             <li>✔ All files in one place</li>
//             <li>✔ Lawyer-client syncing</li>
//             <li>✔ Progress tracking</li>
//             <li>✔ Transparent communication</li>
//             <li>✔ Accountability</li>
            
//           </ul>
//         </motion.div>
//       </div>

//       <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

//         <motion.div initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }}>

//           <h2 className="text-[34px] sm:text-[48px] font-bold text-[#111]">
//             Control Legal Costs
//             <span className="block text-[#cda454]">  & Improve Transparency</span>
//           </h2>

//           <p className="mt-6 text-[#444] text-lg">
//               Gain full visibility into your legal expenses. Track invoices, monitor spending,
//       and ensure better financial control across all your legal operations.
//           </p>

//           <ul className="mt-6 space-y-3 text-[#222]">
//               <li>✔ Expense tracking</li>
//       <li>✔ Invoice management</li>
//       <li>✔ Cost visibility</li>
//       <li>✔ Financial insights</li>
//           </ul>
//         </motion.div>

//         {/* <video
//           src="/videos/video1.mp4"
//           autoPlay
//           loop
//           muted
//           className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
//         />
//       </div> */}

//    <img
//           src="expense_page.jpeg"
          
//           className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
//         />
//       </div>

// <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

//   {/* LEFT CONTENT */}
//   <motion.div initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }}>

//     <h2 className="text-[34px] sm:text-[48px] font-bold text-[#111]">
//       Never Miss a Hearing
//       <span className="block text-[#cda454]">With Smart Case Alerts</span>
//     </h2>

//     <p className="mt-6 text-[#444] text-lg">
//       Stay updated with real-time notifications for hearings, deadlines, and case updates. 
//       Get alerts exactly when you need them and never miss critical legal events.
//     </p>

//     <ul className="mt-6 space-y-3 text-[#222]">
//       <li>✔ Real-time hearing notifications</li>
//       <li>✔ Deadline reminders</li>
//       <li>✔ Case status updates</li>
//       <li>✔ Email & dashboard alerts</li>
//       <li>✔ Smart scheduling sync</li>
//     </ul>

//   </motion.div>

//   {/* RIGHT IMAGE / VIDEO */}
//   <img
//     src="notification.jpeg" // 🔥 replace with your actual image
//     className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
//   />

// </div>






     


//       {/* FEATURES */}
//       <div className="max-w-7xl mx-auto px-6 py-24">
//         <h2 className="text-center text-[30px] sm:text-[44px] font-bold text-[#111] mb-16">
//           How JURIDENT Supports Your Organization
//         </h2>

//         <div className="grid md:grid-cols-3 gap-10">
//           {features.map((item, i) => {
//             const Icon = item.icon;
//             return (
//               <div
//                 key={i}
//                 className="p-8 rounded-3xl border border-[#e5e7eb]
//                 bg-white/70 backdrop-blur-xl transition-all duration-300
//                 hover:border-[#cda454]
//                 hover:shadow-xl hover:-translate-y-2"
//               >
//                 <Icon className="text-[#cda454] mb-4" size={28} />

//                 <h3 className="font-semibold text-[#111] text-lg">
//                   {item.title}
//                 </h3>

//                 <p className="text-[#555] text-sm mt-3 leading-relaxed">
//                   {item.desc}
//                 </p>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* CTA */}
//      <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
//   <div className="bg-gradient-to-br from-white to-[#fafafa] border border-[#e5e7eb] p-14 rounded-3xl shadow-xl">

//     <h2 className="text-[30px] sm:text-[40px] font-bold text-[#111]">
//       Take Control of Your Legal Operations
//     </h2>

//     <p className="mt-4 text-[#555]">
//       Bring clarity, efficiency, and control to your organization with JURIDENT.
//       <br/>
//       Experience the Full Power of the Platform Free for 15 Days.
//     </p>

//     {/* <div className="flex justify-center gap-4 mt-8 flex-wrap">

//       <button className="px-10 py-3 rounded-full bg-black text-white 
//         transition-all duration-300 ease-in-out 
//         hover:scale-105 hover:-translate-y-1 
//         hover:shadow-2xl hover:bg-[#111]">
//         Contact Team
//       </button>

//       <button className="px-10 py-3 rounded-full bg-[#cda454] text-white 
//         transition-all duration-300 ease-in-out 
//         hover:scale-105 hover:-translate-y-1 
//         hover:shadow-2xl hover:bg-[#b8933f]">
//         Get Started
//       </button> */}

//         <div className="mt-10 flex justify-center gap-5 flex-wrap">

//       {/* Get Started */}
//       <a
//         href="/portal"
//         className="
//           px-10 py-3 rounded-full 
//           bg-[#111] text-white font-medium
//           transition-all duration-300
//           hover:scale-105 hover:shadow-lg
//           inline-block
//         "
//       >
//         Get Started
//       </a>

//       {/* Contact (Smooth Scroll) */}
//     <a
//   href="/#help"
//   className="
//     group relative px-10 py-3 rounded-full font-semibold
//     bg-gradient-to-r from-[#cda454] to-[#e6c57a]
//     text-black
//     overflow-hidden
//     transition-all duration-300
//     hover:scale-105 hover:shadow-[0_10px_30px_rgba(205,164,84,0.5)]
//     inline-block
//   "
// >
//   <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 blur-xl transition"></span>

//   <span className="relative flex items-center gap-2">
//     Contact
//     <span className="transform transition group-hover:translate-x-1 text-black">
//       →
//     </span>
//   </span>
// </a>

//     </div>
//   </div>
// </div>

//     </section>
//   );
// };

// export default Enterprise;




























import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import {
  Building2,
  Users,
  Shield,
  Database,
  Layers,
  ArrowRight,
  CalendarClock,
  FileText,
  Sparkles
} from "lucide-react";

const Enterprise = () => {

  const words = ["control", "scalability", "operational excellence"];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const features = [
    {
      icon: Database,
      title: "Centralized Case Management",
      desc: "Maintain a single, secure repository for all legal matters, documents, and case history."
    },
    {
      icon: Users,
      title: "Lawyer-Client Sync",
      desc: "Collaborate seamlessly with lawyers and law firms, track progress, and ensure accountability."
    },
    {
      icon: Sparkles,
      title: "AI-Drafting",
      desc: "Accelerate internal documentation, notices, and case-related drafts with AI support."
    },
    {
      icon: CalendarClock,
      title: "Smart Scheduling & Alerts",
      desc: "Stay ahead of hearings, deadlines, and compliance requirements with automated reminders."
    },
    {
      icon: Users,
      title: "Team Collaboration",
      desc: "Work seamlessly with your team, share updates, and collaborate on cases in real time."
    },
    {
      icon: ArrowRight,
      title: "Expense & Invoice Tracking",
      desc: "Monitor legal spend, manage billing, and improve cost visibility across all cases."
    }
  ];

  return (
    <section className="relative w-full bg-white overflow-hidden">

      {/* Background */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
          backgroundSize: "32px 32px"
        }}
      />

      {/* 🔥 HERO */}
      <div className="max-w-7xl mx-auto px-6 pt-[140px] pb-28 text-center">
        <motion.div initial={{ opacity: 0, y: 60 }} animate={{ opacity: 1, y: 0 }}>

          <h1 className="text-[40px] sm:text-[64px] font-extrabold leading-tight text-[#111]">
            Built to empower enterprise legal teams with
            <span className="block bg-gradient-to-r from-[#cda454] to-[#e6c16a] bg-clip-text text-transparent">
              {" "}
              <motion.span
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="inline-block"
              >
                {words[index]}
              </motion.span>
            </span>
          </h1>

          <p className="mt-6 max-w-3xl mx-auto text-[#444] text-[18px] leading-relaxed">
            JURIDENT helps organizations to 
            Track cases, Get Hearing Notifications, Organize legal documents, and coordinate seamlessly with your legal teams all in one secure platform. Customise with your needs.
          </p>

          {/* BUTTONS */}
          <div className="flex justify-center gap-4 mt-10 flex-wrap">

            <a
              href="/portal"
              className="group relative px-10 py-3 rounded-full bg-[#cda454] text-white font-semibold hover:scale-105 transition inline-block"
            >
              Get Started
            </a>

            <a
              href="/demo"
              className="group relative px-10 py-3 rounded-full border border-[#111] text-[#111] font-semibold hover:scale-105 transition inline-block"
            >
              Book Demo
            </a>
          </div>
        </motion.div>
      </div>

      {/* TRUST BAR */}
      <div className="max-w-6xl mx-auto px-6 pb-20 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
        {["Public sector", "Private sector", "MSMEs", "Government"].map(
          (item, i) => (
            <div
              key={i}
              className="py-6 rounded-xl border border-[#e5e7eb] bg-white/60 backdrop-blur-md
              text-[#111] font-medium transition-all duration-300
              hover:border-[#cda454] hover:shadow-xl hover:-translate-y-1"
            >
              {item}
            </div>
          )
        )}
      </div>

      {/* 🔥 SECTION 1 */}
      <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

        <motion.div initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }}>

          <h2 className="text-[34px] sm:text-[48px] font-bold text-[#111]">
            Manage Legal Matters
            <span className="block text-[#cda454]">With Full Visibility</span>
          </h2>

          <p className="mt-6 text-[#444] text-lg">
            Track every case, document, and update in one centralized system. Stay informed and in control of all legal operations.
          </p>

          <ul className="mt-6 space-y-3 text-[#222]">
            <li>✔ Lawyer-client synchronization.</li>
            <li>✔ Centralized case tracking</li>
            <li>✔ Document organization</li>
            {/* <li>✔ Real-time updates</li> */}
            <li>✔ Better decision making</li>
            <li>✔ AI drafting</li>
            

          </ul>
        </motion.div>

        {/* <video
          src="/videos/video1.mp4"
          autoPlay
          loop
          muted
          className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
        /> */}
          <img
          src="legal.jpeg"
          
          className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
        />
      </div>

      {/* 🔥 SECTION 2 */}
      <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

        <video
          src="legelteam.mp4"
          autoPlay
          loop
          muted
          className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
        />

        <motion.div initial={{ opacity: 0, x: 60 }} whileInView={{ opacity: 1, x: 0 }}>

          <h2 className="text-[34px] sm:text-[48px] font-bold text-[#111]">
            Stay Ahead With
            <span className="block text-[#cda454]">Your Legal Tech</span>
          </h2>

          <p className="mt-6 text-[#444] text-lg">
            Collaborate seamlessly with lawyers and law firms. Track progress, communicate efficiently, and ensure accountability.
          </p>

          <ul className="mt-6 space-y-3 text-[#222]">
            <li>✔ All files in one place</li>
            <li>✔ Lawyer-client syncing</li>
            <li>✔ Progress tracking</li>
            <li>✔ Transparent communication</li>
            <li>✔ Accountability</li>
            
          </ul>
        </motion.div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

        <motion.div initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }}>

          <h2 className="text-[34px] sm:text-[48px] font-bold text-[#111]">
            Control Legal Costs
            <span className="block text-[#cda454]">  & Improve Transparency</span>
          </h2>

          <p className="mt-6 text-[#444] text-lg">
              Gain full visibility into your legal expenses. Track invoices, monitor spending,
      and ensure better financial control across all your legal operations.
          </p>

          <ul className="mt-6 space-y-3 text-[#222]">
              <li>✔ Expense tracking</li>
      <li>✔ Invoice management</li>
      <li>✔ Cost visibility</li>
      <li>✔ Financial insights</li>
          </ul>
        </motion.div>

        {/* <video
          src="/videos/video1.mp4"
          autoPlay
          loop
          muted
          className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
        />
      </div> */}

   <img
          src="expense_page.jpeg"
          
          className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
        />
      </div>

<div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center">

  {/* LEFT CONTENT */}
  <motion.div initial={{ opacity: 0, x: -60 }} whileInView={{ opacity: 1, x: 0 }}>

    <h2 className="text-[34px] sm:text-[48px] font-bold text-[#111]">
      Never Miss a Hearing
      <span className="block text-[#cda454]">With Smart Case Alerts</span>
    </h2>

    <p className="mt-6 text-[#444] text-lg">
      Stay updated with real-time notifications for hearings, deadlines, and case updates. 
      Get alerts exactly when you need them and never miss critical legal events.
    </p>

    <ul className="mt-6 space-y-3 text-[#222]">
      <li>✔ Real-time hearing notifications</li>
      <li>✔ Deadline reminders</li>
      <li>✔ Case status updates</li>
      <li>✔ Email & dashboard alerts</li>
      <li>✔ Smart scheduling sync</li>
    </ul>

  </motion.div>

  {/* RIGHT IMAGE / VIDEO */}
  <img
    src="notification.jpeg" // 🔥 replace with your actual image
    className="rounded-3xl shadow-2xl h-[380px] w-full object-cover"
  />

</div>






     


      {/* FEATURES */}
      <div className="max-w-7xl mx-auto px-6 py-24">
        <h2 className="text-center text-[30px] sm:text-[44px] font-bold text-[#111] mb-16">
          How JURIDENT Supports Your Organization
        </h2>

        <div className="grid md:grid-cols-3 gap-10">
          {features.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="p-8 rounded-3xl border border-[#e5e7eb]
                bg-white/70 backdrop-blur-xl transition-all duration-300
                hover:border-[#cda454]
                hover:shadow-xl hover:-translate-y-2"
              >
                <Icon className="text-[#cda454] mb-4" size={28} />

                <h3 className="font-semibold text-[#111] text-lg">
                  {item.title}
                </h3>

                <p className="text-[#555] text-sm mt-3 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* CTA */}
     <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
  <div className="bg-gradient-to-br from-white to-[#fafafa] border border-[#e5e7eb] p-14 rounded-3xl shadow-xl">

    <h2 className="text-[30px] sm:text-[40px] font-bold text-[#111]">
      Take Control of Your Legal Operations
    </h2>

    <p className="mt-4 text-[#555]">
      Bring clarity, efficiency, and control to your organization with JURIDENT.
      <br/>
      Experience the Full Power of the Platform Free for 15 Days.
    </p>

    {/* <div className="flex justify-center gap-4 mt-8 flex-wrap">

      <button className="px-10 py-3 rounded-full bg-black text-white 
        transition-all duration-300 ease-in-out 
        hover:scale-105 hover:-translate-y-1 
        hover:shadow-2xl hover:bg-[#111]">
        Contact Team
      </button>

      <button className="px-10 py-3 rounded-full bg-[#cda454] text-white 
        transition-all duration-300 ease-in-out 
        hover:scale-105 hover:-translate-y-1 
        hover:shadow-2xl hover:bg-[#b8933f]">
        Get Started
      </button> */}

        <div className="mt-10 flex justify-center gap-5 flex-wrap">

      {/* Get Started */}
      <a
        href="/portal"
        className="
          px-10 py-3 rounded-full 
          bg-[#111] text-white font-medium
          transition-all duration-300
          hover:scale-105 hover:shadow-lg
          inline-block
        "
      >
        Get Started
      </a>

      {/* Contact (Smooth Scroll) */}
    <a
  href="/#help"
  className="
    group relative px-10 py-3 rounded-full font-semibold
    bg-gradient-to-r from-[#cda454] to-[#e6c57a]
    text-black
    overflow-hidden
    transition-all duration-300
    hover:scale-105 hover:shadow-[0_10px_30px_rgba(205,164,84,0.5)]
    inline-block
  "
>
  <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 blur-xl transition"></span>

  <span className="relative flex items-center gap-2">
    Contact
    <span className="transform transition group-hover:translate-x-1 text-black">
      →
    </span>
  </span>
</a>

    </div>
  </div>
</div>

    </section>
  );
};

export default Enterprise;